// extracted by mini-css-extract-plugin
export default {"headerMobile":"AK5rCFOt55ImnIVJl_bt","row":"rQfW_W0QzRyL0nAfmquC","tabs":"PDcA2hUnnrFwqDjH__6N","mobileTabs":"GqAykr2n2rZ3O5ea51N1"};